/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetMediaIdUrlParams,
  TrainWithMeModulesMediaDtosResponsesMediaStatusResponse,
  TrainWithMeModulesMediaDtosResponsesMediaUrlResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const postMediaIdConfirm = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/media/${id}/confirm`, method: 'POST', signal
    },
      options);
    }




export const getPostMediaIdConfirmMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMediaIdConfirm>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMediaIdConfirm>>, TError,{id: number}, TContext> => {

const mutationKey = ['postMediaIdConfirm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMediaIdConfirm>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  postMediaIdConfirm(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostMediaIdConfirmMutationResult = NonNullable<Awaited<ReturnType<typeof postMediaIdConfirm>>>

    export type PostMediaIdConfirmMutationError = ErrorType<unknown>

    export const usePostMediaIdConfirm = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMediaIdConfirm>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMediaIdConfirm>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getPostMediaIdConfirmMutationOptions(options), queryClient);
    }
    export const getMediaIdStatus = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesMediaDtosResponsesMediaStatusResponse>(
      {url: `/media/${id}/status`, method: 'GET', signal
    },
      options);
    }




export const getGetMediaIdStatusQueryKey = (id: number,) => {
    return [
    `/media/${id}/status`
    ] as const;
    }


export const getGetMediaIdStatusQueryOptions = <TData = Awaited<ReturnType<typeof getMediaIdStatus>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaIdStatusQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaIdStatus>>> = ({ signal }) => getMediaIdStatus(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMediaIdStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMediaIdStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaIdStatus>>>
export type GetMediaIdStatusQueryError = ErrorType<unknown>


export function useGetMediaIdStatus<TData = Awaited<ReturnType<typeof getMediaIdStatus>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaIdStatus>>,
          TError,
          Awaited<ReturnType<typeof getMediaIdStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMediaIdStatus<TData = Awaited<ReturnType<typeof getMediaIdStatus>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaIdStatus>>,
          TError,
          Awaited<ReturnType<typeof getMediaIdStatus>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMediaIdStatus<TData = Awaited<ReturnType<typeof getMediaIdStatus>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMediaIdStatus<TData = Awaited<ReturnType<typeof getMediaIdStatus>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdStatus>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMediaIdStatusQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMediaIdUrl = (
    id: number,
    params?: GetMediaIdUrlParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesMediaDtosResponsesMediaUrlResponse>(
      {url: `/media/${id}/url`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetMediaIdUrlQueryKey = (id: number,
    params?: GetMediaIdUrlParams,) => {
    return [
    `/media/${id}/url`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetMediaIdUrlQueryOptions = <TData = Awaited<ReturnType<typeof getMediaIdUrl>>, TError = ErrorType<unknown>>(id: number,
    params?: GetMediaIdUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMediaIdUrlQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMediaIdUrl>>> = ({ signal }) => getMediaIdUrl(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMediaIdUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMediaIdUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getMediaIdUrl>>>
export type GetMediaIdUrlQueryError = ErrorType<unknown>


export function useGetMediaIdUrl<TData = Awaited<ReturnType<typeof getMediaIdUrl>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetMediaIdUrlParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaIdUrl>>,
          TError,
          Awaited<ReturnType<typeof getMediaIdUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMediaIdUrl<TData = Awaited<ReturnType<typeof getMediaIdUrl>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetMediaIdUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMediaIdUrl>>,
          TError,
          Awaited<ReturnType<typeof getMediaIdUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMediaIdUrl<TData = Awaited<ReturnType<typeof getMediaIdUrl>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetMediaIdUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMediaIdUrl<TData = Awaited<ReturnType<typeof getMediaIdUrl>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetMediaIdUrlParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMediaIdUrl>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMediaIdUrlQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






